export const normalizeText = (texto?: string) => {
  if (!texto) {
    return '';
  }

  return texto
    .normalize('NFD') // Normaliza para decompor caracteres acentuados
    .replace(/[\u0300-\u036f]/g, '') // Remove os caracteres de acentuação
    .toLowerCase(); // Converte para minúsculas
};
